import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !key) {
  console.error(
    '[Suricata] Missing Supabase env vars — app will run in degraded mode.\n' +
    'Required: REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY'
  );
}

// Every request the client makes has a deadline (21/10/2026).
//
// The auth client refreshes the access token while it holds a lock, and every
// other getSession() in the tab · each database query, and every call to the
// Finnhub proxy (utils/finnhubClient.js) · waits in line behind it with no
// time limit. A refresh request that never answers (iOS Safari suspends a
// page in the middle of one) kept that lock forever: in production the app
// stopped sending any request at all, while the functions themselves were
// healthy and logged nothing. With a deadline the hung request fails, the
// auth client retries it, and the line moves. A caller's own signal wins.
export const REQUEST_DEADLINE_MS = 15000;

export function fetchWithDeadline(input, init = {}, ms = REQUEST_DEADLINE_MS) {
  if (init.signal) return fetch(input, init);
  const ctl = new AbortController();
  const t = setTimeout(() => ctl.abort(), ms);
  return fetch(input, { ...init, signal: ctl.signal }).finally(() => clearTimeout(t));
}

export const supabase = (url && key)
  ? createClient(url, key, { global: { fetch: (input, init) => fetchWithDeadline(input, init) } })
  : null;
